/* SJ: warm product-card hover images before the pointer arrives (hover devices only). */
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const SEL = '.card-gallery[on\\:pointerenter]';
  const warm = (g) => {
    if (g.dataset.sjWarm) return;
    g.dataset.sjWarm = '1';
    g.querySelectorAll('img[loading="lazy"]').forEach((img) => {
      img.fetchPriority = 'low';
      img.loading = 'eager';
      if (img.decode) img.decode().catch(() => {});
    });
  };
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); warm(e.target); } }), { rootMargin: '400px 0px' })
    : null;
  const scan = (root) => root.querySelectorAll && root.querySelectorAll(SEL).forEach((g) => {
    if (g.dataset.sjObs) return; g.dataset.sjObs = '1'; io ? io.observe(g) : warm(g);
  });
  let busy = false;
  const gridWarm = (e) => {
    if (busy) return; busy = true; setTimeout(() => { busy = false; }, 250);
    const grid = e.target.closest && e.target.closest('.product-grid, ul[product-grid-view], .resource-list');
    if (!grid) return;
    // warm only cards within ~1.5 viewports of the pointer's grid, not the whole catalogue
    const lim = innerHeight * 1.5;
    grid.querySelectorAll(SEL).forEach((g) => { if (g.dataset.sjWarm) return; const r = g.getBoundingClientRect(); if (r.bottom > -lim && r.top < innerHeight + lim) warm(g); });
  };
  const start = () => {
    scan(document);
    document.addEventListener('pointerover', gridWarm, { passive: true });
    new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && scan(n)))).observe(document.body, { childList: true, subtree: true });
  };
  // let primary images win the bandwidth race first
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
})();
